import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useAppSettings } from '../../contexts/AppSettingsContext';

interface StaggeredGridProps {
	children: ReactNode;
	staggerDelay?: number;
}

const container = {
	hidden: {},
	show: (staggerDelay: number) => ({
		transition: {
			staggerChildren: staggerDelay,
		},
	}),
};

const item = {
	hidden: { opacity: 0, y: 12 },
	show: {
		opacity: 1,
		y: 0,
		transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] },
	},
};

export function StaggeredGrid({ children, staggerDelay = 0.08 }: StaggeredGridProps) {
	const { shouldAnimate, durationMultiplier } = useAppSettings();

	if (!shouldAnimate) return <div>{children}</div>;

	return (
		<motion.div
			variants={container}
			initial="hidden"
			animate="show"
			custom={staggerDelay * durationMultiplier}
		>
			{children}
		</motion.div>
	);
}

export function StaggeredItem({ children }: { children: ReactNode }) {
	const { shouldAnimate } = useAppSettings();

	if (!shouldAnimate) return <div>{children}</div>;

	return <motion.div variants={item}>{children}</motion.div>;
}
